import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { GroupCowStatus } from 'models/IGroup'
import React from 'react'

type GroupStatusSelectProps = {
	value: keyof typeof GroupCowStatus | ''
	onChange: (value: keyof typeof GroupCowStatus) => void
	label?: string
	width?: number | string
	disabled?: boolean
}

const GroupStatusSelect: React.FC<GroupStatusSelectProps> = ({
	value,
	onChange,
	label = 'Статус группы',
	width = '100%',
	disabled = false,
}) => {
	return (
		<FormControl
			fullWidth
			sx={{
				width,
				'& label.Mui-focused': {
					color: '#6C3EF8',
					fontSize: '14px',
				},
				'& .MuiOutlinedInput-root': {
					fontSize: '14px',
					borderRadius: '8px',
					'& fieldset': {
						borderColor: 'rgba(0, 0, 0, 0.23)',
					},
					'&:hover fieldset': {
						borderColor: '#6C3EF8',
					},
					'&.Mui-focused fieldset': {
						borderColor: '#6C3EF8',
						borderWidth: '1px',
					},
				},
			}}
		>
			<InputLabel id='group-status-select-label'>{label}</InputLabel>
			<Select
				labelId='group-status-select-label'
				value={value}
				label={label}
				disabled={disabled}
				onChange={e => onChange(e.target.value as keyof typeof GroupCowStatus)}
				renderValue={selected => {
					if (!selected) return ''
					return GroupCowStatus[selected as keyof typeof GroupCowStatus]
				}}
				sx={{
					'& .MuiSelect-select': {
						fontSize: '14px',
					},
				}}
			>
				{Object.keys(GroupCowStatus).map(key => (
					<MenuItem
						key={key}
						value={key}
						sx={{
							fontSize: '14px',
							'&.Mui-selected': {
								backgroundColor: 'rgba(108, 62, 248, 0.08)',
								color: '#6C3EF8',
							},
							'&.Mui-selected:hover': {
								backgroundColor: 'rgba(108, 62, 248, 0.12)',
							},
						}}
					>
						{GroupCowStatus[key as keyof typeof GroupCowStatus]}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	)
}

export default GroupStatusSelect
